

const backendErrorsMessages  = {
  'AccountIsPayout': 'backend-errors.account-is-payout'
}

export function getBackendErrorMessage(err) {
  if (err.response && err.response.data._error_code) {
    const errorMessage = backendErrorsMessages[err.response.data._error_code]
    if (errorMessage) {
      return errorMessage
    }
  }
  return 'notifications.something-went-wrong'
}

